import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { googleImportApi } from "../api/googleImportApi";
import { invalidateShiftQueries } from "../../plantoes/hooks/invalidateShiftQueries";
import { monthRange } from "../utils/monthRange";

const ROOT_KEY = "google-agenda";

export function useGoogleEventsQuery({ year, month }, { enabled = true } = {}) {
  return useQuery({
    queryKey: [ROOT_KEY, "eventos", { year, month }],
    queryFn: () => googleImportApi.listEvents(monthRange(year, month)),
    enabled,
    // 409 (sem conexão) e 503 (Google fora) não melhoram repetindo na hora
    retry: false,
  });
}

// Importar cria plantões (tudo o que depende deles muda) e muda a marca "Já importado".
export function useImportGoogleShiftsMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: googleImportApi.importShifts,
    onSuccess: () => {
      invalidateShiftQueries(queryClient);
      queryClient.invalidateQueries({ queryKey: [ROOT_KEY] });
    },
  });
}
